<template>
  <section class="section is-fullheight">
    <div class="columns is-centered is-flex-mobile">
      <div class="column is-3 is-8-mobile">
        <h3 v-if="logoText" :class="`title is-3 has-text-centered`">{{logoText}}</h3>
        <b-image v-else src="/images/logo.png" />
      </div>
    </div>

    <div v-if="hashedId" class="columns is-centered">
      <div class="column is-5">
        <wistia :id="hashedId" :width="640" :height="361" />
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-5">
        <login-sign-up @userUpdated="$emit('userUpdated', $event)" />
      </div>
    </div>

  </section>
</template>

<script>
import Wistia from '@/components/misc/Wistia';
import LoginSignUp from '@/components/LoginSignUp';

export default {
  components: {
    Wistia,
    LoginSignUp
  },
  data() {
    return {
      hashedId: process.env.VUE_APP_SIGN_UP_VID,
      activeTab: 0,
      logoText: process.env.VUE_APP_LOGO_TEXT
    }
  }
}
</script>